import { render, staticRenderFns } from "./FundDetails.vue?vue&type=template&id=d1f40c02&scoped=true&"
import script from "./FundDetails.vue?vue&type=script&lang=js&"
export * from "./FundDetails.vue?vue&type=script&lang=js&"
import style0 from "./FundDetails.vue?vue&type=style&index=0&id=d1f40c02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f40c02",
  null
  
)

export default component.exports